import { Modal } from '@bp/ui-components';
import type { BpClassType } from 'pages/Institution/subpages/InstitutionClassesSubpage';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ClassGroupProfilesForm } from '../forms/ClassGroupProfilesForm';

export type lassGroupProfilesModalProps = {
  bpClass: BpClassType;
  isOpen: boolean;
  onClose: () => void;
};

export const ClassGroupProfilesModal = ({ bpClass, isOpen, onClose }: lassGroupProfilesModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal loading={loading} title={t('classes.assignGroupProfiles')} isOpen={isOpen} onRequestClose={onClose}>
      <ClassGroupProfilesForm bpClass={bpClass} onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
